import { Paper } from '@mui/material'
import React from 'react'

const AccountPaper = React.forwardRef(
  ({ elevation = 0, className, ...props }, ref) => {
    return (
      <Paper
        style={{
          borderRadius: 12
        }}
        className={className}
        ref={ref}
        {...props}
      />
    )
  }
)

export default AccountPaper
